import React, { memo, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { useConfig } from '@browsing/config';
import { scrollToTop } from '@browsing/utils';
import { RoundButton } from '../round-button';
import { ChatBox } from './chat-box';
import { BottomBubbleContext } from './context';
import * as S from './styles';
var DEBOUNCE_TIME = 100;
var SHOW_BACK_TO_TOP_THRESHOLD = 300;
var onScrollClick = function () { return scrollToTop(); };
export var BottomBubble = function (_a) {
    var children = _a.children, customer = _a.customer;
    var config = useConfig();
    var _b = useState(false), isBackToTopButtonShown = _b[0], setBackToTopButtonShown = _b[1];
    var _c = useState(0), marginBottom = _c[0], setMarginBottom = _c[1];
    useEffect(function () {
        var onScroll = debounce(function () {
            if (window.scrollY > SHOW_BACK_TO_TOP_THRESHOLD) {
                if (!isBackToTopButtonShown) {
                    setBackToTopButtonShown(true);
                }
            }
            else {
                setBackToTopButtonShown(false);
            }
        }, DEBOUNCE_TIME);
        window.addEventListener('scroll', onScroll);
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, [isBackToTopButtonShown]);
    return (React.createElement(BottomBubbleContext.Provider, { value: setMarginBottom },
        children,
        React.createElement(S.Container, { "$bottom": marginBottom || 0 },
            config.isEnabled('livechat') && React.createElement(ChatBox, { customer: customer }),
            React.createElement(S.ArrowContainer, { "$visible": isBackToTopButtonShown },
                React.createElement(RoundButton, { onClick: onScrollClick },
                    React.createElement(S.ArrowUpIcon, null))))));
};
export default memo(BottomBubble);
